/**
 * Legacy LoggerService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.logger`) keep resolving.
 *
 * The actual `LoggerService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts as a downgrade
 * of the Angular 18 LoggerService at
 * apps/b2b-frontend/app/core/logger/logger.service.ts.
 *
 * Do NOT register `.service('LoggerService', ...)` here — it would shadow
 * the downgraded service and reintroduce the legacy implementation.
 */
angular.module('acme.common.service.logger', []);
